
import SsrCarousel from 'vue-ssr-carousel'
// eslint-disable-next-line no-unused-vars
import ssrCarouselCss from 'vue-ssr-carousel/index.css'
import optionsData from '@/data/options.json';
import bannerData from '@/data/banner.json';

export default {
  components: { SsrCarousel },
  props:{
    region:{
      type:String,
      default:'UK',
    },
  },
  data(){
      return{
        options: optionsData,
        banner: bannerData
      }
    },
  computed: {
    early() {
      const d = new Date();
      const bfDate = new Date('2023-11-24')
      if (d < bfDate){
        return true;
      } else {
        return false
      }
    },
    currentMonth() {
      const month = ["January","February","March","April","May","June","July","August","September","October","November","December"];
      const d = new Date();
      const name = month[d.getMonth()];
      return name
    },
    discount_amount(){
      const amount = this.$props.region === 'US' ? this.banner.discount_amount_us_bf : this.banner.discount_amount_bf;
      return amount
    },
    headline1(){
      const headline = this.$props.region === 'US' ? this.banner.slider_headline_1_us : this.banner.slider_headline_1;
      return headline
    },
    headline2(){
      const headline2 = this.$props.region === 'US' ? this.banner.slider_headline_2_us : this.banner.slider_headline_2;
      return headline2
    },
    subheading(){
      const subheading = this.$props.region === 'US' ? this.banner.slider_subheading_us : this.banner.slider_subheading;
      return subheading
    }
  },
  methods: {
    // Push a hero banner click to GTM (primary) and mirror to RudderStack
    trackHeroClick(bannerName, element, event) {
      const link = event && event.currentTarget
      // read the resolved href so we don't re-implement the region URL logic
      const destination = (link && link.getAttribute('href')) || ''

      // GTM - primary pipeline
      this.$gtm.push({
        event: 'hero_banner_click',
        banner_name: bannerName,     // which slide
        banner_element: element,     // 'ticket' or 'button'
        banner_region: this.region,
        banner_destination: destination
      });

      // RudderStack - backup mirror, Klaviyo off as per the lead pattern
      this.$rs.track('Hero Banner Click', {
        banner_name: bannerName,
        banner_element: element,
        banner_region: this.region,
        banner_destination: destination
      }, {
        integrations: {
          "Klaviyo": false,
        },
      });
    }
  }
}
